<template lang="html">

<div class="modal modal-right small fade" id="log-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title info-title">Informations de connexion</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="computed_filters.establishment__uid != null"
                     class="accordion accordion-flush"
                     id="accordionLog">
                    <div v-for="item, index in connections"
                         class="accordion-item">
                        <div class="accordion-header"
                             id="flush-headingOne">
                            <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                :data-bs-target="'#flush-collapse' + index"
                                aria-expanded="false"
                                :aria-controls="'flush-collapse' + index"
                                style="font-size: 1.2em !important">
                                
                                {{ item.platform.name }}
                            </button>
                        </div>
                        <div
                            :id="'flush-collapse' + index"
                            class="accordion-collapse collapse"
                            aria-labelledby="flush-headingOne"
                            data-bs-parent="#accordionLog"
                        >
                            <div class="accordion-body">

                                <div class="row g-2 mb-2">
                                    <div class="col-2 text-muted"><i class="icon-16 bi-person me-2"></i></div>
                                    <div class="col">{{ item.login }}</div>
                                </div>
                                <div class="row g-2 mb-2">
                                    <div class="col-2 text-muted cursor-pointer"><i class="icon-16 bi-key me-2" @click="copyPass(index)"></i></div>
                                    <div class="col cursor-pointer" @click="copyPass(index)">password</div>
                                    <textarea class="col hide" :ref="'pass' + index">{{ item.password }}</textarea>
                                </div>
                                <div class="row g-2">
                                    <div class="col-2 text-muted"><i class="icon-16 bi-link me-2"></i></div>
                                    <div class="col"> <a :href="item.establishment_link" target="_blank" >Voir la fiche</a></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-0">
                <div class="btn-group" role="group">
                    <button class="btn btn-outline-primary" type="button" data-bs-dismiss="modal" aria-label="Close">Fermer</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import CONNECTION_SET from '@/gql/queries/connectionSet.graphql';
import { gqlQuery } from '@/gqlClient.js';

export default {
  name: 'EstablishmentModal',
  components: {},
  computed: {
    computed_filters() {
      return {
        establishment__uid: this.$store.state.selected_establishment_uid
      };
    }
  },
  data() {
    return {
      connections: []
    };
  },
  methods: {
    async fetch_connections() {
      const uid = this.$store.state.selected_establishment_uid;
      if (!uid) return;
      const res = await gqlQuery(CONNECTION_SET, { establishment_uid: uid });
      this.connections = res.body.data.connection_set || [];
    },
    async query() {
      await this.fetch_connections();
    },
    copyPass(index) {
      const refLabel = 'pass' + index;
      const el = this.$refs[refLabel][0];
      el.select();
      document.execCommand('copy');
      this.$store.dispatch('notify', {
        level: 'success',
        text: 'Copié!',
        seconds: 2
      });
    }
  },
  watch: {
    '$store.state.selected_establishment_uid'(newV, oldV) {
      if (newV) {
        this.fetch_connections();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.info-title {
    font-size: 1.1em !important;
    font-weight: 400;
}
.hide {
    opacity: 0; 
    width:0px;
    height:0px;
}
#log-modal {
    z-index: 100000;
}
.modal-content {
    width: 100%;
}
</style>
